import FaveBizAPI from 'integrations/FaveBizAPI';

export default ({ id }: { id: number }) => FaveBizAPI.delete(`/v1/feed/${id}`);
